import { useContext, useEffect, useState } from 'react'
import moment from 'moment'

import { Modal, Input, DateInput, Textarea, DateInputV2, Checkbox } from '../ui_new'
import { dateValueFormat } from '../../utils'
import { Send } from '@material-ui/icons'
import { Close } from '../../assets/icons'
import { NotificationContext, UserContext, ValidationContext } from '../../context'
import { add_document_event } from '../../services/firestore'
import { Cancel } from '@mui/icons-material'

const TEST_DISPLAY_USER_ID = false // TODO disable - For testing purposes only - display user ID in user labels

const StartValidationModal = ({ onClose, document, documentId, template }) => {

  const VALIDATION_TYPES = {
    PARTIAL: 'partial',
    FINAL: 'final',
  }

  const { setNotification } = useContext(NotificationContext)
  const { createValidation } = useContext(ValidationContext)
  const { validators, user } = useContext(UserContext)
  const [type, setType] = useState(VALIDATION_TYPES.PARTIAL) // partial | final
  const [currentUserInput, setCurrentUserInput] = useState('')
  const [assignedUsers, setAssignedUsers] = useState([])
  const [comment, setComment] = useState('')
  const [deadline, setDeadline] = useState('')

  const [filteredUsers, setFilteredUsers] = useState([])
  const [showUsersDropdown, setShowUsersDropdown] = useState(false)
  

  useEffect(() => {
    const normalizeString = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

    const filtered = validators.filter(validator => `${validator.id}` !== `${user.id}`).filter(validator => {
      // if(assignedUsers.some(assignedUser => assignedUser.id === user.id)) return false
      if(!currentUserInput || currentUserInput.trim() === '') return true
      const searchPhrases = currentUserInput.split(' ').map(phrase => normalizeString(phrase))
      const searchFields = [normalizeString(validator.firstname || ''), normalizeString(validator.lastname || ''), normalizeString(validator.email || '')]
      return searchFields.some(field => searchPhrases.some(phrase => field.includes(phrase)))
    })
    setFilteredUsers([
      ...filtered,
    ])
  }, [validators, currentUserInput, assignedUsers, user])

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault()
    if(assignedUsers.length === 0) {
      setNotification({
        type: 'danger',
        msg: 'Veuillez sélectionner au moins une personne à assigner.'
      })
      return
    }
    const validation = {
      documentId: documentId,
      documentName: document.name,
      templateId: document.template,
      type: type,
      assignedUsers: assignedUsers,
      comment: comment,
      validators: [...assignedUsers]
    }
    if(deadline) {
      validation.deadline = moment(deadline, dateValueFormat).valueOf()
    }
    const response = await createValidation(validation)

    await add_document_event(documentId, {
      type: 'validation_request',
      validators: [...assignedUsers],
      comment: comment,
      deadline: deadline ? moment(deadline, dateValueFormat).valueOf() : null,
      values: document.values || {},
      content_changes: document.content_changes || [],
    })
    if(response?.error) {
      setNotification({
        type: 'danger',
        msg: response.error.message || 'Une erreur est survenue lors de l\'envoi de la validation.'
      })
      return
    }
    setNotification({
      type: 'success',
      msg: 'Validation envoyée avec succès.'
    })
    setAssignedUsers([])
    setCurrentUserInput('')
    setComment('')
    setDeadline('')
    setFilteredUsers([])
    setType('final')
    // Close modal
    onClose()
  }

  const userLabel = (user) => {
    const includeId = TEST_DISPLAY_USER_ID
    const includeStatus = TEST_DISPLAY_USER_ID
    if(user.firstname && user.lastname) {
      return `${user.firstname} ${user.lastname}` + (includeId ? ` (${user.id})` : '') + (includeStatus && user.status ? ` - ${user.status}` : '')
    }
    if(user.lastname) {
      return user.lastname + (includeId ? ` (${user.id})` : '') + (includeStatus && user.status ? ` - ${user.status}` : '')
    }
    if(user.email) {
      return user.email + (includeId ? ` (${user.id})` : '') + (includeStatus && user.status ? ` - ${user.status}` : '')
    }
    return 'Utilisateur' + (includeId ? ` (${user.id})` : '') + (includeStatus && user.status ? ` - ${user.status}` : '')
  }

  const toggleAssignedUser = (user) => {
    if(!assignedUsers.some(assignedUser => assignedUser.id === user.id)) {
      setAssignedUsers([...assignedUsers, {...user}])
    } else {
      setAssignedUsers(assignedUsers.filter(assignedUser => assignedUser.id !== user.id))
    }
    setCurrentUserInput('')
    setShowUsersDropdown(false)
  }

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--medium-3">
      <div className='modal-v2__heading'>
          <div>
            <h2>Envoyer en révision </h2>
          </div>
        <div className="buttons-row desktop">
          <button className="btn btn--transparent" onClick={onClose}>Annuler</button>
          <button className="btn btn--with-icon btn--large" onClick={handleSubmit}><Send fontSize='small' className='mr-2' /> Envoyer</button>
        </div>
      </div>
      <div className='modal-v2__body'>
        <div className="tab-selector tab-selector--small flex w-full mb-4">
          <div className={`w-1/2 ${type === VALIDATION_TYPES.PARTIAL ? 'active' : ''}`} onClick={(e) => setType(VALIDATION_TYPES.PARTIAL)}>
            Révision partielle
          </div>
          <div className={`w-1/2 ${type === VALIDATION_TYPES.FINAL ? 'active' : ''}`} onClick={(e) => setType(VALIDATION_TYPES.FINAL)}>
            Révision finale
          </div>
        </div>
        <div>
          <div className="input-wrapper">
            <Input
              value={currentUserInput}
              onFocus={() => setShowUsersDropdown(true)}
              onBlur={(e) => {
                e.preventDefault()
                // Delay hiding the dropdown to allow click event to register
                setTimeout(() => {
                  setShowUsersDropdown(false)
                }, 150)
              }}
                // setShowUsersDropdown(currentUserInput.trim() !== '')}
              type="string"
              onChange={(e) => setCurrentUserInput(e.target.value)}
              className={currentUserInput ? 'not-empty' : ''}
              label={'Affection révision'}
              placeholder={'Sélectionnez une ou plusieurs personnes'}
              required />
          </div>
          {showUsersDropdown && (
            <div className="filtered-users validation-modal__filtered-users">
              {filteredUsers.map((user, index) => (
                <div className={`filtered-user ${assignedUsers.some(assignedUser => assignedUser.id === user.id) ? 'selected' : ''}`} key={`filtered-user-${index}`} onClick={() => toggleAssignedUser(user)}>
                  <Checkbox checked={assignedUsers.some(assignedUser => assignedUser.id === user.id)} />
                  <span className="filtered-user--name">{userLabel(user)}</span>
                </div>
              ))}
            </div>
          )}
          {assignedUsers.length > 0 && (
            <div className="badges-row">
              {/* display a badge with user name and a cross icon to remove the user */}
              {assignedUsers.map((user, index) => (
                <div className="assigned-user" key={`assigned-user-${index}`}>
                  <span className="assigned-user--name">{userLabel(user)}</span>
                  <span className="assigned-user--remove" onClick={() => setAssignedUsers(assignedUsers.filter((_, i) => i !== index))}><Close /></span>
                </div>
              ))}
            </div>
          )}
          <div className="textarea-wrapper mt-4">
            <Textarea
              label={'Commentaire général'}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className={comment ? 'not-empty' : ''}
              placeholder={' - '}
            />
          </div>
          {type === 'final' && (
              <div className={`${deadline ? 'date_picker-v2 not-empty' : 'date_picker-v2'} mt-4`}>
                <DateInputV2
                  label={'Date limite de validation'}
                  selected={!deadline ? '' : new Date(moment(deadline, dateValueFormat).valueOf())}
                  onChange={date => date ? setDeadline(moment(date.valueOf()).format(dateValueFormat)) : ''}
                  dateFormat="dd/MM/yyyy"
                  isClearable={deadline}
                  className={`date-input-v2--light ${deadline ? 'not-empty' : ''}`}
                  placeholder={'JJ/MM/AAAA'}
                  peekNextMonth={true}
                  // showMonthDropdown={true}
                  // showYearDropdown={true}
                  dropdownMode="select"
                  onClearableClick={() => setDeadline('')}
                  minDate={new Date()}
                />
              </div>
          )}
        </div>

        <div className="modal-v2__buttons-footer mobile">
          <button className="modal-v2__btn modal-v2__btn-danger" onClick={onClose}><Cancel /> Annuler</button>
          <button className="modal-v2__btn modal-v2__btn-primary" onClick={handleSubmit}><Send fontSize='small' className='mr-2' /> Envoyer</button>
        </div>
      </div>
    </Modal>
  )
}

export default StartValidationModal